import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import Slider from "@cars24/turbo-web/lib/slider";
import { SocialTestimonialCard } from "@cars24/turbo-web/lib/social-testimonial-card";
import { getDate } from "./selector";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";

const EChallanTestimonials = ({ challanTestimonialsData }) => {

    const { title: heading = "", testimonialList = [] } = challanTestimonialsData || {};

    const handleSlideChange = async (e) => {
        const slideIndex = e && e.track && e.track.details && e.track.details.rel;
        await yieldToMain();
        sendCustomGaEvents({ eventLabel: slideIndex });
    };

    return (
        <div styleName={"styles.testimonialWrapper"}>
            {testimonialList.length > NUMBER.ZERO &&
                <Slider width="100%" height="100%" slideToShow={4} gap={16} showDots={false} variant="primary" title={heading} onSlideChange={handleSlideChange}>
                    {testimonialList.map(({ id = "", userDesignation = "", image = {}, userName = "", description = "", publishedDate = "" }) => {
                        return (
                            <SocialTestimonialCard
                                key={id}
                                profileHandle={userDesignation}
                                profileImageUrl={image.url || ""}
                                profileName={userName}
                                testimonial={description}
                                dateValue={getDate(publishedDate)}
                                isBackgroundColor={false}
                                isBorder={true}
                                profileImageLoading="lazy"
                            />
                        );
                    }
                    )}
                </Slider>
            }
        </div>
    );
};

EChallanTestimonials.propTypes = {
    challanTestimonialsData: PropTypes.object
};

export default EChallanTestimonials;
